/**
 * Frequently Bought Together - Default Variations Handler & Size Chart Integration
 * Auto-select default variations and add size charts for variable products in FBT sections
 */
jQuery(document).ready(function ($) {
	'use strict';
	/**
	 * Initialize default variation selection and size charts for FBT products
	 */
	function initFBTDefaultVariations() {
		sortVariationOptions();

		$('.iconic-wsb-bump-product__select').each(function () {
			const $select = $(this);
			const productId = $select.data('product_id');

			// Skip if no product ID or already has a selected value
			if (!productId || $select.val()) {
				return;
			}

			// Get product's default variation via AJAX
			getDefaultVariation(productId, $select);
		});

		// Add size charts to FBT products
		addSizeChartsToFBT();
	}

	/**
	 * Get default variation for a product via AJAX
	 *
	 * @param {number} productId - The product ID
	 * @param {jQuery} $select - The select element
	 */
	function getDefaultVariation(productId, $select) {
		$.ajax({
			url: lanumaFBT.ajax_url,
			type: 'POST',
			data: {
				action: 'get_default_variation',
				product_id: productId,
				nonce: lanumaFBT.nonce,
			},
			success: function (response) {
				if (response.success && response.data.variation_id) {
					selectDefaultVariation($select, response.data.variation_id);
				}
			},
		});
	}

	/**
	 * Select the default variation in the select element
	 *
	 * @param {jQuery} $select - The select element
	 * @param {number} variationId - The variation ID to select
	 */
	function selectDefaultVariation($select, variationId) {
		const $option = $select.find('option[value="' + variationId + '"]');

		if ($option.length) {
			// Remove selected from placeholder
			$select.find('option[disabled][selected]').prop('selected', false);

			// Select the default variation
			$option.prop('selected', true);
			$select.val(variationId);

			// Trigger change event for any listeners
			$select.trigger('change');

			// Update hidden attribute field if it exists
			updateAttributesField($select, variationId);
		}
	}

	/**
	 * Update the hidden attributes field for the selected variation
	 *
	 * @param {jQuery} $select - The select element
	 * @param {number} variationId - The selected variation ID
	 */
	function updateAttributesField($select, variationId) {
		const productId = $select.data('product_id');
		const $option = $select.find('option[value="' + variationId + '"]');
		const attributesData = $option.data('attributes');

		if (attributesData && productId) {
			const $attributesField = $(
				'input[name="iconic-wsb-bump-product_attributes-' +
					productId +
					'"]'
			);
			if ($attributesField.length) {
				$attributesField.val(JSON.stringify(attributesData));
			}
		}
	}

	/**
	 * Add size charts to FBT products
	 */
	function addSizeChartsToFBT() {
		$('.iconic-wsb-bump-product__body').each(function () {
			const $productBody = $(this);
			const $listItem = $productBody.closest(
				'.iconic-wsb-product-bumps__list-item'
			);
			const productId = $listItem.data('product_id');

			// Skip if already has size chart or no product ID
			if (
				$productBody.find('.lanuma-fbt-size-chart').length ||
				!productId
			) {
				return;
			}

			// Get size chart for this product
			getSizeChartForProduct(productId, $productBody);
		});
	}

	/**
	 * Get size chart data for a product via AJAX
	 *
	 * @param {number} productId - The product ID
	 * @param {jQuery} $productBody - The product body element
	 */
	function getSizeChartForProduct(productId, $productBody) {
		$.ajax({
			url: lanumaFBT.ajax_url,
			type: 'POST',
			data: {
				action: 'get_fbt_size_chart',
				product_id: productId,
				nonce: lanumaFBT.nonce,
			},
			success: function (response) {
				if (response.success && response.data.size_chart_html) {
					addSizeChartToProduct(
						$productBody,
						response.data.size_chart_html,
						productId
					);
				}
			},
		});
	}

	/**
	 * Add size chart HTML to product
	 *
	 * @param {jQuery} $productBody - The product body element
	 * @param {string} sizeChartHtml - The size chart HTML
	 * @param {number} productId - The product ID
	 */
	function addSizeChartToProduct($productBody, sizeChartHtml, productId) {
		const $priceElement = $productBody.find(
			'.iconic-wsb-bump-product__price'
		);

		if ($priceElement.length) {
			// Create container for size chart with both classes
			const $sizeChartContainer = $(
				'<div class="lanuma-fbt-size-chart lanuma-fbt-size-chart-' +
					productId +
					'"></div>'
			);
			$sizeChartContainer.html(sizeChartHtml);

			// Update popup ID and add generic class to popup div
			$sizeChartContainer
				.find('a[href^="#"]')
				.attr('href', '#lanuma-fbt-size-chart-' + productId);
			$sizeChartContainer
				.find('.mfp-hide')
				.attr('id', 'lanuma-fbt-size-chart-' + productId)
				.addClass('lanuma-fbt-popup');

			// Insert after price
			$priceElement.after($sizeChartContainer);

			// Re-initialize Magnific Popup for new elements
			if (typeof $.magnificPopup !== 'undefined') {
				$sizeChartContainer
					.find('.lanuma-size-fit-popup-btn')
					.magnificPopup({
						type: 'inline',
						midClick: true,
						closeBtnInside: false,
						closeOnBgClick: true,
						showCloseBtn: true,
						enableEscapeKey: true,
					});
			}
		}
	}

	/**
	 * Sort variation options in the desired order: SMALL, BASIC, PLUS
	 */
	/**
	 * Sort variation options in the desired order
	 */
	function sortVariationOptions() {
		$('.iconic-wsb-bump-product__select').each(function () {
			const $select = $(this);
			const $options = $select.find('option:not([disabled])');

			// Define the desired orders for different size systems
			const pajkiceSizeOrder = ['small', 'basic', 'plus'];
			const motionSizeOrder = ['xs', 's', 'm', 'l', 'xl', '2xl'];

			// Sort options based on the size attribute
			const sortedOptions = $options.sort(function (a, b) {
				const aData = $(a).data('attributes');
				const bData = $(b).data('attributes');

				if (!aData || !bData) return 0;

				// Check which size attribute system is being used
				let aSize, bSize, sizeOrder;

				if (aData.attribute_pa_velikost) {
					// Pajkice system (SMALL, BASIC, PLUS)
					aSize = aData.attribute_pa_velikost.slug;
					bSize = bData.attribute_pa_velikost?.slug;
					sizeOrder = pajkiceSizeOrder;
				} else if (aData.attribute_pa_motion_velikost) {
					// Motion system (XS, S, M, L, XL, 2XL)
					aSize = aData.attribute_pa_motion_velikost.slug;
					bSize = bData.attribute_pa_motion_velikost?.slug;
					sizeOrder = motionSizeOrder;
				}

				if (!aSize || !bSize) return 0;

				const aIndex = sizeOrder.indexOf(aSize);
				const bIndex = sizeOrder.indexOf(bSize);

				// If size not found in order array, put it at the end
				const aPos = aIndex === -1 ? 999 : aIndex;
				const bPos = bIndex === -1 ? 999 : bIndex;

				return aPos - bPos;
			});

			// Remove existing options and append sorted ones
			$options.detach();
			$select.append(sortedOptions);
		});
	}

	/**
	 * Handle variation selection changes
	 */
	function handleVariationChange() {
		$(document).on(
			'change',
			'.iconic-wsb-bump-product__select',
			function () {
				const $select = $(this);
				const variationId = $select.val();

				if (variationId) {
					updateAttributesField($select, variationId);
				}
			}
		);
	}

	/**
	 * Move the coupon notice to appear before the bundle section
	 */
	function repositionFrequentlyBoughtTogether() {
		const $fbtSection = $('.iconic-wsb-product-bumps');
		const $couponNotice = $('.lanuma--single-product--coupon-notice');

		// If both elements exist and coupon hasn't been moved yet
		if (
			$fbtSection.length &&
			$couponNotice.length &&
			!$couponNotice.hasClass('coupon-repositioned')
		) {
			// Move coupon notice to appear right before bundle section
			$couponNotice.insertBefore($fbtSection);

			// Mark coupon as repositioned and show the bundle element
			$couponNotice.addClass('coupon-repositioned');
			$fbtSection.css('display', 'block');

			return true;
		}

		return false;
	}

	/**
	 * Attempt to reposition with retry logic
	 */
	let repositionComplete = false;

	function attemptRepositioning() {
		if (repositionComplete) return true;

		if (repositionFrequentlyBoughtTogether()) {
			repositionComplete = true;
			return true;
		}

		return false;
	}

	/**
	 * Initialize repositioning
	 */
	function initFBTRepositioning() {
		// Reset flag for new attempts
		repositionComplete = false;

		// Try with 500ms delay
		setTimeout(() => attemptRepositioning(), 500);
	}

	// Initialize when DOM is ready
	initFBTDefaultVariations();
	handleVariationChange();
	//initFBTRepositioning();

	// Re-initialize if content is loaded dynamically (e.g., via AJAX)
	$(document).on(
		'updated_cart_totals updated_checkout updated_wc_div',
		function () {
			setTimeout(initFBTDefaultVariations, 100);
			setTimeout(initFBTRepositioning, 150);
		}
	);
});
